<template>
  <div class="biography">
    <img class="biography-map" src="@/assets/img/biography-map.png" alt="biography-map">
    <BaseText1 text="biography"/>
    <div class="stat-group bottom-stat-group">
      <div class="stat-item">
        <BaseText5 text="Hometown"/>
        <BaseText10 :text="opponentHometown"/>
      </div>
    </div>
    <div class="stat-group">
      <div class="stat-item">
        <BaseText5 text="Age"/>
        <BaseText10 :text="opponentAge"/>
      </div>
      <div class="stat-item">
        <BaseText5 text="Height"/>
        <BaseText10 :text="opponentHeight"/>
      </div>
      <div class="stat-item">
        <BaseText5 text="Weight"/>
        <BaseText10 :text="opponentWeight"/>
      </div>
    </div>
  </div>
</template>

<script>
import BaseText1 from '@/components/BaseText1/BaseText1'
import BaseText5 from '@/components/BaseText5/BaseText5'
import BaseText10 from '@/components/BaseText10/BaseText10'
export default {
  components: {
    BaseText1,
    BaseText5,
    BaseText10
  },
  props: {
    opponentHometown: {
      type: String,
      required: true
    },
    opponentAge: {
      type: String,
      required: true
    },
    opponentHeight: {
      type: String,
      required: true
    },
    opponentWeight: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.biography {
  position: relative;
  .biography-map {
    position: absolute;
    top: 0;
    right: 0;
  }
  .base-text-10 {
    margin: -0.3rem 0 0 0;
  }
}
.stat-group {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  white-space: nowrap;
  margin: 2rem 0 0 0;
  .stat-item:not(:last-child) {
    margin-right: 2rem
  }
}
.stat-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}
</style>
